var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg001House(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M392,512H120C53.8,512,0,458.1,0,392V223.7c0-37.2,17.7-72.9,47.2-95.4l136-103.7c42.8-32.7,102.7-32.7,145.5,0 L372,57.5V32c1.1-26.5,39-26.5,40,0v65.9c0,7.6-4.3,14.5-11.1,17.9c-6.8,3.4-15,2.6-21-2l-75.4-57.4c-28.6-21.8-68.5-21.8-97,0 l-136,103.7c-19.7,15-31.5,38.8-31.5,63.6V392c0,44.1,35.9,80,80,80h272c44.1,0,80-35.9,80-80V223.7c0-25.1-11.6-49-31.1-63.8 c-8.8-6.7-10.5-19.2-3.8-28c6.7-8.8,19.2-10.5,28-3.8c29.3,22.4,46.9,58.1,46.9,95.6V392C512,458.1,458.2,512,392,512z M216,231 c-13.8,0-25,11.2-25,25c1.3,33.2,48.7,33.1,50,0C241,242.2,229.8,231,216,231z M321,256c-1.3,33.2-48.7,33.1-50,0 C272.3,222.8,319.7,222.8,321,256z M241,336c-1.3,33.2-48.7,33.1-50,0C192.3,302.8,239.7,302.8,241,336z M321,336 c-1.3,33.2-48.7,33.1-50,0C272.3,302.8,319.7,302.8,321,336z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg001House);
export default __webpack_public_path__ + "static/media/001-house.41e86ee8a7a8c4ea02cda3fa7d442555.svg";
export { ForwardRef as ReactComponent };